import apis from '../config/apis'
import { getAttribute } from './models'
import { request as httpRequest } from './http'

export const request = async (name, additionalConfig = {}) => {
    const config = { ...apis[name], ...additionalConfig }
    let { url } = config
    let options = null

    if (config.hasOwnProperty('auth')) {
        try {
            // const response = await axios.post(config.auth.url,
            //     {
            //         'client_id': config.auth.clientId,
            //         'client_secret': config.auth.clientSecret,
            //         'grant_type': config.auth.grantType
            //     },
            //     {
            //         headers: {
            //             'Accept': 'application/json',
            //             'Content-Type': 'application/json',
            //         }
            //     })

            options = {
                params: { access_token: 'ee8cfd31f0c08279ddda50283ee31234a6191a4c' }
            }
        } catch (error) {
            throw error
        }
    }

    return httpRequest(url, options)
}

export const getValueAttribute = (name) => {
    const config = apis[name]

    return config.valueAttribute
}

export const getLabelAttribute = (name) => {
    const config = apis[name]

    return config.labelAttribute
}

export const getApi = (model, attribute) => {
    return getAttribute(model, attribute).api
}


// WEBPACK FOOTER //
// ./src/utils/apis.js